export default {
  info_label: 'Ingresa la siguiente información para la generación de tu comprobante.',
  warning_label:
    'En caso de que no desees datos del comprobante, se generará un comprobante como consumidor final.',
  input_nit: {
    label: 'RUC:',
    placeholder: 'Ingresa un RUC',
    error: {
      required: 'El campo RUC es requerido',
      format: 'Debe especificar un RUC válido'
    }
  },
  input_address: {
    label: 'Dirección de comprobante:',
    placeholder: 'Ingresa la dirección de comprobante',
    error: {
      length: 'Su dirección debe de contener máximo 200 caracteres',
      format: 'Su dirección debe contener caracteres válidos'
    }
  },
  input_email: {
    label: 'Correo electrónico para tu comprobante:',
    placeholder: 'Ingresa tu correo',
    error: {
      format: 'Debe especificar un correo electrónico válido',
      domain: 'Debe especificar un correo @gmail.com, @hotmail.com, @msn.com o @outlook.com'
    }
  }
}
